import React from 'react';
import { AlertTriangle, Ban } from 'lucide-react';
import { KEYPAD_SEVERITY } from '../catalog/issue';
import type { KeypadIssue } from '../catalog/issue';

export interface IssueListProps {
  issues: readonly KeypadIssue[];
}

/**
 * What is wrong with a panel, worst first.
 *
 * A blocking issue means the device would refuse the mapping or act on something
 * other than what is on screen; an advisory one is worth knowing and does not
 * stop the write. Separating them is the difference between "fix this" and "read
 * this".
 */
export const IssueList: React.FC<IssueListProps> = ({ issues }) => {
  if (issues.length === 0) return <></>;
  const blocking = issues.filter((issue) => issue.severity === KEYPAD_SEVERITY.BLOCKING);
  const advisory = issues.filter((issue) => issue.severity !== KEYPAD_SEVERITY.BLOCKING);

  const row = (issue: KeypadIssue) => (
    <li key={issue.code + issue.message} className="flex items-start gap-2 text-sm">
      {issue.severity === KEYPAD_SEVERITY.BLOCKING ? (
        <Ban className="mt-0.5 h-4 w-4 shrink-0 text-[#C0392B]" />
      ) : (
        <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-[#D4A054]" />
      )}
      <span className={issue.severity === KEYPAD_SEVERITY.BLOCKING ? 'text-[#C0392B]' : 'text-[#8A6A2A]'}>
        {issue.message}
      </span>
    </li>
  );

  return (
    <div className="space-y-2">
      {blocking.length > 0 && <ul className="space-y-1.5">{blocking.map(row)}</ul>}
      {advisory.length > 0 && <ul className="space-y-1.5">{advisory.map(row)}</ul>}
    </div>
  );
};

export default IssueList;
